import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isFunction } from 'lodash';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { CTAButton } from 'shared-components/buttons/cta-button';
import CreateItemFormContainer from '../../app-main/components/reduxForms/forms/CreateItemForm/CreateItemFormContainer';
import Button from '../../elements-buttons/Button';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

class CreateAddOnModal extends Component {
  constructor (props) {
    super(props);

    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount () {
    const { showModal, scrollToTop } = this.props;
    if (isFunction(scrollToTop) && showModal) {
      scrollToTop();
    }
  }

  closeModal () {
    this.props.toggleModal();
  }

  render () {
    const {
      currency,
      createItem,
      onModalClose,
      isSubmitting,
      isMobile,
      toggleModal,
      iosWebView,
      whichModal,
      spaceId,
      initialValues,
      fromManageAddons,
      isVatEnabled,
      intlCollectVatCopy,
      intlAddOnTaxTypes
    } = this.props;

    return (
      <div className="CreateAddOnModal">
        {
          iosWebView && ('createAddOnModal' === whichModal) ?
            <div className="create-item-form-ios">
              <div>
                <span className="pull-right ico ico-sm icon-close-sidebar" onClick={this.closeModal} />
                <h3>
                  <FormattedMessage
                    id="inbox.create_add_on_modal.create_item"
                    defaultMessage="Create an inventory item"
                  />
                </h3>
              </div>

              <CreateItemFormContainer
                currency={currency}
                isMobile={isMobile}
                toggleModal={toggleModal}
                fromManageAddons={fromManageAddons}
                spaceId={spaceId}
                iosWebView
                isVatEnabled={isVatEnabled}
                intlCollectVatCopy={intlCollectVatCopy}
                intlAddOnTaxTypes={intlAddOnTaxTypes}
              />

              <CTAButton
                buttonText={ this.props.intl.formatMessage({ id: 'inbox.create_add_on_modal.save_addon', defaultMessage: 'Save Add-on' }) }
                classNameString="btn btn-primary form"
                onClickAction={createItem}
                isDisabled={ false }
                spinning={isSubmitting}
                attributes={{ 'data-testing-id': 'create-add-on-button' }}
              />
            </div>
            :
            <BootstrapModal
              {...this.props}
              modalSize="sm-size"
              modalClass="create-add-on-modal"
              header={ <h3><FormattedMessage id="inbox.create_add_on_modal.create_addon_item" defaultMessage="Create add-on item" /></h3> }
              onClose={onModalClose}
              body={
                <CreateItemFormContainer
                  currency={currency}
                  isMobile={isMobile}
                  toggleModal={toggleModal}
                  spaceId={spaceId}
                  initialValues={initialValues}
                  fromManageAddons={fromManageAddons}
                  isVatEnabled={isVatEnabled}
                  intlCollectVatCopy={intlCollectVatCopy}
                  intlAddOnTaxTypes={intlAddOnTaxTypes}
                />
              }
              footer={
                <Button
                  category="primary"
                  onClick={createItem}
                  attributes={{ 'data-testing-id': 'create-add-on-button' }}
                  isLoading={isSubmitting}
                >
                  <FormattedMessage
                    id="inbox.create_add_on_modal.save"
                    defaultMessage="Save Item"
                  />
                </Button>
              }
            />
        }
      </div>
    );
  }
}

CreateAddOnModal.propTypes = {
  errorMsg: PropTypes.string,
  currency: PropTypes.string,
  createItem: PropTypes.func,
  categories: PropTypes.array,
  onModalClose: PropTypes.func,
  isSubmitting: PropTypes.bool,
  isMobile: PropTypes.bool,
  toggleModal: PropTypes.func,
  scrollToTop: PropTypes.func,
  booking: PropTypes.object,
  iosWebView: PropTypes.bool,
  whichModal: PropTypes.string,
  spaceId: PropTypes.string,
  contracts: PropTypes.object,
  initialValues: PropTypes.object,
  fromManageAddons: PropTypes.bool,
  showModal: PropTypes.bool,
  intl: intlShape,
  isVatEnabled: PropTypes.bool,
  intlCollectVatCopy: PropTypes.object,
  intlAddOnTaxTypes: PropTypes.array
};

exports.CreateAddOnModal = injectIntl(CreateAddOnModal);
